<div dropdown class="dropdown" keyboard-nav="true" triggers="">
  <button
    dropdownToggle
    id="qf_dd"
    class="btn btn-default columns dropdown-toggle shrink"
    data-bs-toggle="dropdown"
    type="button"
    [tooltip]="quickFilterTooltipTemplate"
    [isDisabled]="!isFilterLabelTruncated"
    placement="bottom"
    rlElementOverflowListener
    (elementTruncated)="onFilterLabelTruncate($event)"
    [elementSelector]="'.filter-menu__label--truncated'"
  >
    <span class="filter-menu__label--truncated">
      <ng-container i18n="@@quickFiltersMenu-btn-filter">Filter:</ng-container>
      &ngsp;
      <ng-container [ngSwitch]="quickFilter ? true : false">
        <ng-container *ngSwitchCase="true">
          <rl-quick-filter-label
            [quickFilterId]="quickFilter.id"
            [quickFilterType]="quickFilter.type"
            [quickFilterValue]="quickFilter.value"
          >
          </rl-quick-filter-label
          >&nbsp;
        </ng-container>
        <ng-container *ngSwitchDefault i18n="@@quickFiltersMenu-btn-all"
          >All</ng-container
        >
      </ng-container>
    </span>
  </button>

  <ng-template #quickFilterTooltipTemplate>
    <ng-container [ngSwitch]="quickFilter ? true : false">
      <rl-quick-filter-label
        *ngSwitchCase="true"
        [quickFilterId]="quickFilter.id"
        [quickFilterType]="quickFilter.type"
        [quickFilterValue]="quickFilter.value"
      >
      </rl-quick-filter-label>
      <ng-container *ngSwitchDefault i18n="@@quickFiltersMenu-tooltip-all"
        >All</ng-container
      >
    </ng-container>
  </ng-template>

  <ul class="dropdown-menu" *dropdownMenu>
    <li>
      <button
        class="dropdown-item filter-menu__button"
        (click)="onClearAll($event)"
        type="button"
        id="qf_remove-all"
      >
        <ng-container i18n="@@quickFiltersMenu-btn-removeAll">
          All
        </ng-container>
        <span class="filter-menu__item-count">{{ itemCount?.totalItems }}</span>
      </button>
    </li>

    <li *ngFor="let statusFilter of courseReserveStatusFilters">
      <button
        [id]="'qf_course-reserve-status-' + statusFilter.value"
        class="dropdown-item filter-menu__button"
        type="button"
        [attr.aria-labelledby]="
          'qf_dd qf_course-reserve-status-' + statusFilter.value
        "
        [ngSwitch]="statusFilter.value"
        (click)="onQuickFilterByCourseReserveStatus(statusFilter)"
      >
        <rl-quick-filter-label
          [quickFilterId]="statusFilter.value"
          [quickFilterType]="'courseReserveStatus'"
          [quickFilterValue]="statusFilter.label"
        >
        </rl-quick-filter-label>
        <span class="filter-menu__item-count">{{
          itemCount?.itemCountByCourseReserveStatus.get(statusFilter.value, 0)
        }}</span>
      </button>
    </li>

    <li class="dropdown-divider" role="presentation"></li>

    <li *ngFor="let resourceTypeFilter of resourceTypeFilters">
      <button
        [id]="'qf_resource-type-' + resourceTypeFilter.isOnlineResource"
        class="dropdown-item filter-menu__button"
        type="button"
        [attr.aria-labelledby]="
          'qf_dd qf_resource-type-' + resourceTypeFilter.isOnlineResource
        "
        (click)="onQuickFilterByResourceType(resourceTypeFilter)"
      >
        <rl-quick-filter-label
          [quickFilterId]="resourceTypeFilter.isOnlineResource"
          [quickFilterType]="'resourceType'"
          [quickFilterValue]="resourceTypeFilter.label"
        >
        </rl-quick-filter-label>
        <span class="filter-menu__item-count">{{
          itemCount?.itemCountByPhysicalOrOnlineResourceType.get(
            resourceTypeFilter.isOnlineResource,
            0
          )
        }}</span>
      </button>
    </li>

    <li
      *ngIf="showHasLibraryNoteFilter"
      class="dropdown-divider"
      role="presentation"
    ></li>

    <li *ngIf="showHasLibraryNoteFilter">
      <button
        id="qf_resource-type-library-note"
        class="dropdown-item filter-menu__button"
        type="button"
        (click)="onQuickFilterByHasLibraryNote()"
      >
        <rl-quick-filter-label
          [quickFilterId]="'hasLibraryNote'"
          [quickFilterType]="'hasLibraryNote'"
          [quickFilterValue]="'Has library note'"
        >
        </rl-quick-filter-label>
        <span class="filter-menu__item-count">{{
          itemCount?.itemCountForHasLibraryNote
        }}</span>
      </button>
    </li>

    <li
      *ngIf="readingIntentions.length > 0"
      class="dropdown-divider"
      role="presentation"
    ></li>

    <li *ngFor="let intention of readingIntentions">
      <button
        [id]="'qf_intention-' + intention.value"
        class="dropdown-item filter-menu__button"
        [class.disabled]="!areAnnotationsResolved"
        type="button"
        [disabled]="!areAnnotationsResolved"
        [attr.aria-labelledby]="'qf_dd qf_intention-' + intention.value"
        (click)="areAnnotationsResolved && onQuickFilterByIntention(intention)"
      >
        <rl-quick-filter-label
          [quickFilterId]="intention.value"
          [quickFilterType]="'readingIntention'"
          [quickFilterValue]="intention.label"
        >
        </rl-quick-filter-label>
        <span class="filter-menu__item-count">{{
          areAnnotationsResolved
            ? itemCount?.itemCountByReadingIntention.get(intention.value, 0)
            : null
        }}</span>
      </button>
    </li>

    <li
      *ngIf="digitisationStatusFilters.length > 0"
      class="dropdown-divider"
      role="presentation"
    ></li>

    <li *ngFor="let statusFilter of digitisationStatusFilters">
      <button
        [id]="'qf_digitisation-status-' + statusFilter.value"
        class="dropdown-item filter-menu__button"
        type="button"
        [attr.aria-labelledby]="
          'qf_dd qf_digitisation-status-' + statusFilter.value
        "
        [ngSwitch]="statusFilter.value"
        (click)="onQuickFilterByDigitisationStatus(statusFilter)"
      >
        <rl-quick-filter-label
          [quickFilterId]="statusFilter.value"
          [quickFilterType]="'digitisationStatus'"
          [quickFilterValue]="statusFilter.label"
        >
        </rl-quick-filter-label>
        <span class="filter-menu__item-count">{{
          itemCount?.itemCountByDigitisationStatus.get(statusFilter.value, 0)
        }}</span>
      </button>
    </li>

    <li
      *ngIf="importances.length > 0"
      class="dropdown-divider"
      role="presentation"
    ></li>

    <ng-container *ngIf="importances.length > 0">
      <li *ngFor="let importance of importances">
        <button
          [id]="'qf_importance-' + importance.id"
          class="dropdown-item filter-menu__button"
          type="button"
          [attr.aria-labelledby]="'qf_dd qf_importance-' + importance.id"
          (click)="onQuickFilterByImportance(importance)"
        >
          <rl-quick-filter-label
            [quickFilterId]="importance.id"
            [quickFilterType]="'importance'"
            [quickFilterValue]="importance.description"
          >
          </rl-quick-filter-label>
          <span class="filter-menu__item-count">{{
            itemCount?.itemCountByImportance.get(importance.id, 0)
          }}</span>
        </button>
      </li>
      <li
        *ngIf="studyNoteFilters.length > 0"
        class="dropdown-divider"
        role="presentation"
      ></li>
      <li *ngIf="isEditMode()">
        <button
          [id]="'qf_importance-no-importance-set'"
          class="dropdown-item filter-menu__button"
          type="button"
          [attr.aria-labelledby]="'qf_dd qf_importance-no-importance-set'"
          (click)="onQuickFilterByNoImportanceSet()"
        >
          <rl-quick-filter-label
            [quickFilterId]="noImportanceSet.id"
            [quickFilterType]="'importance'"
            [quickFilterValue]="noImportanceSet.value"
          >
          </rl-quick-filter-label>
          <span class="filter-menu__item-count">{{
            itemCount?.itemCountByImportance.get(noImportanceSet.id, 0)
          }}</span>
        </button>
      </li>
    </ng-container>

    <li *ngFor="let studyNoteFilter of studyNoteFilters">
      <button
        [id]="'qf_study-note-present-' + studyNoteFilter.isPresent"
        class="dropdown-item filter-menu__button"
        [class.disabled]="!areAnnotationsResolved"
        type="button"
        [disabled]="!areAnnotationsResolved"
        [attr.aria-labelledby]="
          'qf_dd qf_study-note-present-' + studyNoteFilter.isPresent
        "
        (click)="
          areAnnotationsResolved &&
            onQuickFilterByStudyNotePresent(studyNoteFilter)
        "
      >
        <rl-quick-filter-label
          [quickFilterId]="studyNoteFilter.isPresent"
          [quickFilterType]="'studyNotes'"
          [quickFilterValue]="studyNoteFilter.label"
        >
        </rl-quick-filter-label>
        <span class="filter-menu__item-count">{{
          areAnnotationsResolved
            ? itemCount?.itemCountByStudyNote.get(studyNoteFilter.isPresent, 0)
            : null
        }}</span>
      </button>
    </li>
  </ul>
</div>
